import { GlossaryTerm } from '~/types';
import splitTermTitle from '~/ui/components/TextWithTerms/utils/splitTermTitle';

const startsWith = (query: string, text: string) =>
  text.toLowerCase().startsWith(query.toLowerCase());

const extendQueryToMatch = (query: string, text: string) => {
  if (!startsWith(query, text)) return '';

  const initialMatch = text.substring(0, query.length);
  const followingMatch = text.substring(query.length).match(/^\S+/)?.[0] || '';

  return initialMatch + followingMatch;
};

const createMatch = (startPos: number, matchQuery: string) => ({
  endPos: startPos + matchQuery.length,
  textMatch: matchQuery,
});

/**
 * Finds a glossary term in the text.
 *
 * Recognizes:
 * - Full term: "Long title (short title)"
 * - Long form: "Long title"
 * - Short form: "short title"
 * - Partial variants (e.g., "Long titles")
 *
 * Note: Assumes the text content begins with a valid match.
 */
const findMatch = (term: GlossaryTerm, textContent: string) => {
  const [longPart, shortPart] = splitTermTitle(term.title);
  const startPos = term.position || 0;
  const targetText = textContent.substring(startPos, textContent.length);

  if (startsWith(term.title, targetText)) {
    return createMatch(startPos, extendQueryToMatch(term.title, targetText));
  }

  if (longPart && startsWith(longPart, targetText)) {
    return createMatch(startPos, extendQueryToMatch(longPart, targetText));
  }

  if (shortPart && startsWith(shortPart, targetText)) {
    return createMatch(startPos, extendQueryToMatch(shortPart, targetText));
  }

  return createMatch(startPos, '');
};

export default findMatch;
